import { ROUND_START_SEQUENCE_MS } from "@craftoff/game-core";

export type BattleIntroPhase =
  | { kind: "matchup"; key: "matchup" }
  | { kind: "round"; key: string }
  | { kind: "countdown"; key: string; seconds: number };

export function battleIntroPhase(round: number, seconds: number): BattleIntroPhase {
  const roundSequenceSeconds = ROUND_START_SEQUENCE_MS / 1_000;
  if (round === 1 && seconds > roundSequenceSeconds) {
    return { kind: "matchup", key: "matchup" };
  }
  if (seconds >= roundSequenceSeconds) {
    return { kind: "round", key: `round-${round}` };
  }
  return { kind: "countdown", key: `countdown-${seconds}`, seconds };
}
